import { useContext } from 'react';

import { ExamCenterProctorDetailsContext } from './exam-center-proctor-details-provider';

function useExamCenterProctorDetails() {
  const context = useContext(ExamCenterProctorDetailsContext);

  if (!context) {
    throw new Error(
      'useExamCenterProctorDetails must be used within a ExamCenterProctorDetailsProvider',
    );
  }

  return context;
}

export { useExamCenterProctorDetails };
